import {Fragment, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {FormatDisplay} from '../../../shared/format';

import {MGateWayService} from '../../lich-su-truyen-nhan/MGateWayService';
import {ToastService} from '../../../AppToast';
import {ConfirmDialogService} from '../../../AppConfirmDialog';

import {TransferLogs} from '../../lich-su-truyen-nhan/component/TransferLogs';
import  EventEmitter  from '../../../utils/EventEmitter';

export const DialogViewTransferLog = (props) => {

  const type = 'Invoice,InvoiceCode,InvoiceCash';
  const sendTaxStatusError = 5;
  
  const {display, setDisplay, selectedItem} = props;
  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);
  const [canRevert, setCanRevert] = useState(false);

  const rollbackStatus = () => {
    ConfirmDialogService.confirm('Xác nhận', 'Bạn có thực sự muốn khôi phục trạng thái hoá đơn về Chờ ký để gửi lại CQT không?', () => {
      MGateWayService.rollbackStatus(type, [selectedItem.id]).then(() => {
        setVersion(Date.now());
        ToastService.success('Khôi phục thành công');
      });
    });
  }

  const revertStatus = () => {
    const searchInvoice =  {
      invoiceId: selectedItem.id,
      taxCode: selectedItem.sellerTaxCode,
      invoiceDate:selectedItem.invoiceDate,
      invoiceNo: selectedItem.invoiceNumber,
      invoiceSerial: selectedItem.invoiceSerial,
      sendTaxStatus: selectedItem.invoiceSerial
    };

    ConfirmDialogService.confirm('Xác nhận', 'Bạn có thực sự muốn lấy lại thông điệp thành công?', () => {
      MGateWayService.revertStatus(searchInvoice).then(() => {
        setVersion(Date.now());
        ToastService.success('Lấy thành công');
        EventEmitter.emit("reloadInvoiceData");
      });
    });
  }

  const getResult = () => {
    if((selectedItem.sendTaxStatus === sendTaxStatusError)) {
      revertStatus();
    } else {
      reloadResult();
    }
  }

  const reloadResult = () => {
      MGateWayService.getResult(selectedItem.id, type).then(() => {
      setVersion(Date.now());
      ToastService.success('Tải lại thành công');
      EventEmitter.emit("reloadInvoiceData");
    });
  }   

  return (
    <Dialog header="Lịch sử truyền nhận hoá đơn" visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
      {selectedItem &&
				<Fragment>
					<p className="text-center"><b style={{fontSize: '1.25rem', fontWeight: 700}}>Ký hiệu {selectedItem.invoiceSerial}, số {selectedItem.invoiceNumber}, ngày {FormatDisplay.date(selectedItem.invoiceDate)}</b></p>
					<TransferLogs type={type} invoice={selectedItem} rows={20} heightCalc={200} idAction={selectedItem.id} version={version} sendTaxStatus = {selectedItem.sendTaxStatus}
												setCanRollback={setCanRollback}/>
				</Fragment>
      }

      <div className="flex justify-content-end mt-2">
        {/* {canRollback &&
					<Button label="Khôi phục trạng thái" className="p-button-outlined p-button-sm mr-2" onClick={rollbackStatus}/>
        } */}
        <Button label="Kiểm tra" className="p-button-outlined p-button-sm mr-2" onClick={getResult}/>
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}